import { API_URL, BROADCAST_LOCATION_API_TOKEN } from '../../config';
import { applyPreproductionSettings } from '../../utils/PreproductionSettings';

const fetchWithAuth = async (url: string, lang: string) => {
  url = applyPreproductionSettings(url);
  if (lang.includes('zh')) {
    url += url.includes('?') ? '&locale=zh-Hant-HK&fallbackLocale=false' : '?locale=zh-Hant-HK&fallbackLocale=false';
  }
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${BROADCAST_LOCATION_API_TOKEN}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

export const fetchBroadcastLocation = async (lang: string) => {
  try {
    const broadcastLocationResponse = await fetchWithAuth(
      `${API_URL}/live-broadcast-location?populate=Original.Banner.BannerImage,Original.Banner.BannerImageTab,Original.Banner.BannerImageMob,Original.Locations,Original.GA,Original.SEO.MetaImage,Special.Banner.BannerImage,Special.Banner.BannerImageTab,Special.Banner.BannerImageMob,Special.Locations,Special.GA,Special.SEO.MetaImage&pagination[limit]=-1`,
      lang
    );

    const broadcastLocation = broadcastLocationResponse.data;

    console.log('fetchBroadcastLocation API Response:', broadcastLocation);
    return broadcastLocation;
  } catch (error) {
    console.error('Error fetching packs.', error);
    return null;
  }
};